export const mobileInputExcludedCountries = (isSweden: boolean): string[] => {
  const countries = [
    'af',
    'al',
    'dz',
    'as',
    'ao',
    'ai',
    'ag',
    'ar',
    'am',
    'aw',
    'au',
    'az',
    'bs',
    'bb',
    'be',
    'bz',
    'bj',
    'bm',
    'bt',
    'bq',
    'bw',
    'bv',
    'br',
    'io',
    'bg',
    'bf',
    'bi',
    'kh',
    'cm',
    'cv',
    'ky',
    'cf',
    'td',
    'cx',
    'cc',
    'km',
    'cd',
    'ck',
    'cr',
    'ci',
    'cu',
    'cw',
    'cy',
    'cz',
    'dk',
    'dj',
    'dm',
    'do',
    'ec',
    'sv',
    'gq',
    'er',
    'ee',
    'et',
    'fo',
    'fj',
    'fr',
    'gf',
    'pf',
    'tf',
    'ga',
    'gm',
    'gh',
    'gr',
    'gl',
    'gd',
    'gp',
    'gu',
    'gt',
    'gn',
    'gw',
    'gy',
    'ht',
    'hm',
    'va',
    'hn',
    'hk',
    'hu',
    'id',
    'ir',
    'iq',
    'il',
    'it',
    'jm',
    'kz',
    'kp',
    'kg',
    'la',
    'lv',
    'ls',
    'lr',
    'ly',
    'lt',
    'mg',
    'mw',
    'my',
    'mv',
    'ml',
    'mh',
    'mq',
    'mr',
    'mu',
    'yt',
    'fm',
    'me',
    'ms',
    'ma',
    'mz',
    'mm',
    'na',
    'nr',
    'np',
    'nc',
    'ni',
    'ne',
    'ng',
    'nu',
    'nf',
    'mp',
    'pk',
    'pw',
    'ps',
    'pa',
    'pg',
    'ph',
    'pn',
    'pl',
    'pt',
    'pr',
    're',
    'ro',
    'rw',
    'bl',
    'sh',
    'kn',
    'lc',
    'mf',
    'pm',
    'vc',
    'ws',
    'st',
    'sn',
    'sc',
    'sl',
    'sg',
    'sk',
    'si',
    'sb',
    'so',
    'gs',
    'ss',
    'es',
    'lk',
    'sd',
    'sr',
    'sj',
    'sz',
    'se',
    'ch',
    'sy',
    'tj',
    'tz',
    'tl',
    'tg',
    'tk',
    'to',
    'tt',
    'tn',
    'tr',
    'tm',
    'tc',
    'tv',
    'ug',
    'us',
    'um',
    'uy',
    'uz',
    'vu',
    'vg',
    'vi',
    'wf',
    'eh',
    'ye',
    'zm',
    'zw',
  ];

  if (isSweden) {
    countries.splice(countries.indexOf('se'), 1);
  }

  return countries;
};
